import React from 'react'

export default function ClaimLogoEditor({
  preview,
  hasClaimLogo = false,
  busy = false,
  onUpload,
  onClear,
  compact = false,
}) {
  return (
    <div className="flex items-center gap-2">
      {preview ? (
        <img
          src={preview}
          alt=""
          className={`${compact ? 'h-10 w-16' : 'h-14 w-20'} shrink-0 rounded border border-slate-200 bg-white object-contain p-0.5`}
          loading="lazy"
        />
      ) : (
        <div className={`${compact ? 'h-10 w-16' : 'h-14 w-20'} flex shrink-0 items-center justify-center rounded border border-dashed border-slate-300 bg-slate-50 text-[11px] text-slate-400`}>
          로고
        </div>
      )}
      <div className="flex flex-col gap-1">
        <label className="w-fit cursor-pointer rounded border px-2 py-1 text-xs hover:bg-slate-50">
          <input
            type="file"
            accept="image/png,image/jpeg,image/webp,image/svg+xml"
            className="hidden"
            disabled={busy}
            onChange={(e) => {
              const file = e.target.files?.[0]
              e.target.value = ''
              onUpload?.(file)
            }}
          />
          {busy ? '처리 중…' : '업로드'}
        </label>
        {hasClaimLogo ? (
          <button
            type="button"
            className="w-fit text-xs text-rose-700 underline disabled:opacity-50"
            onClick={onClear}
            disabled={busy}
          >
            해제
          </button>
        ) : null}
      </div>
    </div>
  )
}
